import {css} from "@emotion/react";

export const root = css`
  border-radius: 4px;
  border-color: #a9a9a9;
  padding: 8px;
  outline: none;
  
  &:focus {
    border-color: #4f4f4f;
  }
`;


export const rootFullWidth = css`
  width: 100%;
`;